(() => {
  const rankMap = new Map([
    ['XXS',0],['2XS',0],['XS',1],['S',2],['M',3],['L',4],['XL',5],
    ['XXL',6],['2XL',6],['XXXL',7],['3XL',7],['4XL',8],['5XL',9],['6XL',10]
  ]);
  const normalize = (value) => String(value || '').trim().toUpperCase().replace(/\s+/g,'');
  const sizeRank = (value) => rankMap.get(normalize(value));
  const heightRank = (cm) => {
    if (cm < 158) return 0;
    if (cm < 165) return 1;
    if (cm < 171) return 2;
    if (cm < 182) return 3;
    if (cm < 189) return 4;
    if (cm < 196) return 5;
    return 6;
  };
  const familyOffset = (family) => ['oversized-hoodie','zipper-hoodie','jersey'].includes(family) ? 1 : 0;
  const buildOffset = (cm, kg) => {
    const m = cm / 100;
    const index = kg / (m * m);
    if (index < 18.5) return -1;
    if (index < 28) return 0;
    if (index < 33) return 1;
    return 2;
  };
  const fitOffset = (fit) => fit === 'closer' ? -1 : fit === 'looser' ? 1 : 0;
  const nearestAvailable = (sizes, target) => {
    const candidates = sizes.map((label, order) => ({label, order, rank:sizeRank(label)})).filter((item) => Number.isFinite(item.rank));
    if (!candidates.length) return null;
    candidates.sort((a,b) => {
      const ad = Math.abs(a.rank-target), bd = Math.abs(b.rank-target);
      if (ad !== bd) return ad-bd;
      const aBelow = a.rank < target ? 1 : 0;
      const bBelow = b.rank < target ? 1 : 0;
      if (aBelow !== bBelow) return aBelow-bBelow;
      return a.order-b.order;
    });
    return candidates[0].label;
  };
  const init = (root) => {
    if (root.dataset.hnFitReady === 'true') return;
    root.dataset.hnFitReady = 'true';
    const dialog = root.querySelector('dialog');
    const open = root.querySelector('[data-hn-fit-open]');
    const close = root.querySelector('[data-hn-fit-close]');
    const unitButtons = root.querySelectorAll('[data-hn-unit]');
    const metric = root.querySelector('[data-hn-metric]');
    const imperial = root.querySelector('[data-hn-imperial]');
    const error = root.querySelector('[data-hn-fit-error]');
    const result = root.querySelector('[data-hn-fit-result]');
    let unit = 'metric';
    const showDialog = () => { if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open',''); };
    const hideDialog = () => { if (dialog.close) dialog.close(); else dialog.removeAttribute('open'); };
    open?.addEventListener('click', showDialog);
    close?.addEventListener('click', hideDialog);
    dialog?.addEventListener('click', (event) => { if (event.target === dialog) hideDialog(); });
    unitButtons.forEach((button) => button.addEventListener('click', () => {
      unit = button.dataset.hnUnit;
      unitButtons.forEach((item) => item.classList.toggle('is-active', item === button));
      metric.hidden = unit !== 'metric';
      imperial.hidden = unit !== 'imperial';
      error.hidden = true;
    }));
    root.querySelector('[data-hn-fit-calculate]')?.addEventListener('click', () => {
      let cm, kg;
      if (unit === 'metric') {
        cm = Number(root.querySelector('[data-hn-height-cm]')?.value);
        kg = Number(root.querySelector('[data-hn-weight-kg]')?.value);
      } else {
        const ft = Number(root.querySelector('[data-hn-height-ft]')?.value);
        const inch = Number(root.querySelector('[data-hn-height-in]')?.value || 0);
        const lb = Number(root.querySelector('[data-hn-weight-lb]')?.value);
        cm = ((ft * 12) + inch) * 2.54;
        kg = lb * 0.45359237;
      }
      if (!Number.isFinite(cm) || !Number.isFinite(kg) || cm < 130 || cm > 220 || kg < 35 || kg > 200) {
        error.textContent = root.dataset.error || '';
        error.hidden = false;
        result.hidden = true;
        return;
      }
      const selectedFit = root.querySelector('input[type="radio"]:checked')?.value || 'intended';
      const target = Math.max(0, Math.min(10, heightRank(cm) + buildOffset(cm,kg) + familyOffset(root.dataset.family) + fitOffset(selectedFit)));
      const sizes = (root.dataset.sizes || '').split('|').map((value) => value.trim()).filter(Boolean);
      const recommendation = nearestAvailable(sizes, target);
      if (!recommendation) {
        error.textContent = root.dataset.error || '';
        error.hidden = false;
        result.hidden = true;
        return;
      }
      error.hidden = true;
      root.querySelector('[data-hn-result-label]').textContent = root.dataset.resultLabel || '';
      root.querySelector('[data-hn-result-size]').textContent = recommendation;
      root.querySelector('[data-hn-result-note]').textContent = root.dataset.resultNote || '';
      result.hidden = false;
    });
  };
  const initAll = (scope=document) => scope.querySelectorAll('[data-hn-fit-finder]').forEach(init);
  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
